import { useCallback } from 'react';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';

const useUpdateSearchParams = () => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const createQueryString = useCallback(
    (updates: Record<string, string[] | string | null>) => {
      const params = new URLSearchParams(searchParams.toString());

      Object.entries(updates).forEach(([name, value]) => {
        if (value === null || value === undefined) {
          params.delete(name);
        } else if (Array.isArray(value)) {
          if (value.length > 0) {
            params.set(name, value.join(','));
          } else {
            params.delete(name);
          }
        } else if (value) {
          params.set(name, value);
        } else {
          params.delete(name);
        }
      });

      return params.toString();
    },
    [searchParams],
  );

  const updateSearchParams = (
    params: Record<string, string[] | string | null>,
  ) => {
    const queryString = createQueryString(params);
    router.push(`${pathname}?${queryString}`, { scroll: false });
  };

  const clearSearchParams = () => {
    router.push(pathname, { scroll: false });
  };

  return { updateSearchParams, clearSearchParams };
};

export { useUpdateSearchParams };
